import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import App from "./App";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { QueryClient, QueryClientProvider } from "react-query";
import 'react-modern-drawer/dist/index.css'
import { LocalizationProvider } from "@mui/x-date-pickers";

const root = ReactDOM.createRoot(document.getElementById("root"));
const client = new QueryClient();
const darkTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#000000",
    },
    secondary: {
      main: "#ffffff",
    },
  },
});
root.render(
  <>
    <ThemeProvider theme={darkTheme}>
      <ToastContainer
        theme="dark"
        position="top-center"
        autoClose={3000}
        closeOnClick
        pauseOnFocusLoss={false}
        pauseOnHover={false}
        className="!w-1/4 !capitalize"
      />
      {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}
      <QueryClientProvider client={client}>
        <App />
      </QueryClientProvider>
      {/* </LocalizationProvider> */}
    </ThemeProvider>
  </>
);
